import { dateFns as moment } from '@pcln/date-fns-utils'

function calculateLengthOfStay(startDate, endDate) {
  const firstDay = moment(startDate)
  const lastDay = moment(endDate)
  return lastDay.diff(firstDay, 'days')
}

export { calculateLengthOfStay }
